import { fetchGet, fetchPost } from "@/lib/services";

export async function getBranchZoneEmployees(
  status: 'tele' | 'delivery',
  params?: { Branch_Code?: string; Zone_Code?: string; Employee?: string }
) {
  const q = new URLSearchParams({ Status: status });
  if (params?.Branch_Code) q.set('Branch_Code', params.Branch_Code);
  if (params?.Zone_Code) q.set('Zone_Code', params.Zone_Code);
  if (params?.Employee) q.set('Employee', params.Employee);
  return await fetchGet(`/branch-zone-employees/?${q}`);
}

export async function getEmployeesBranchwise(params: { Branch_Code?: string; Employee?: string }) {
  const q = new URLSearchParams();
  if (params.Branch_Code) q.set('Branch_Code', params.Branch_Code);
  if (params.Employee) q.set('Employee', params.Employee);
  return await fetchGet(`/register-employees-branchwise/?${q}`);
}

export async function submitTeleRecord(data: object) {
  return await fetchPost("/tele-record/", data);
}

export async function getTeleRecords(params?: {
  Employee?: string;
  Username?: string;
  Date?: string;
  Status?: string;
}) {
  const q = new URLSearchParams();
  if (params?.Employee) q.set('Employee', params.Employee);
  if (params?.Username) q.set('Username', params.Username);
  if (params?.Date) q.set('Date', params.Date);
  if (params?.Status) q.set('Status', params.Status);
  const qs = q.toString();
  return await fetchGet(`/tele-record/${qs ? '?' + qs : ''}`);
}
